(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["twilly-shop-look"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('twilly-look')) {
  customElements.define('twilly-look', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', (event) => {
        if (event.target.matches('select[name="id"]')) {
          const option = event.target.selectedOptions[0];
          event.target.closest('[data-item]').querySelector('[data-price]').textContent = option.dataset.price;
        }
      });
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('[data-look-form]')) return;
        event.preventDefault();
        this.addItems([{id: Number(new FormData(event.target).get('id')), quantity: 1}]);
      });
      this.querySelector('[data-add-all]')?.addEventListener('click', () => {
        const items = Array.from(this.querySelectorAll('[data-item]'))
          .filter(row => row.querySelector('[data-include]').checked && !row.querySelector('[data-include]').disabled)
          .map(row => ({id: Number(row.querySelector('select[name="id"]').value), quantity: 1}));
        if (!items.length) {
          this.querySelector('[role="status"]').textContent = this.dataset.empty;
          return;
        }
        this.addItems(items);
      });
    }
    async addItems(items) {
      if (this.busy) return;
      this.busy = true;
      const buttons = Array.from(this.querySelectorAll('button:not(:disabled)'));
      buttons.forEach(button => button.disabled = true);
      const status = this.querySelector('[role="status"]');
      status.textContent = '';
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.add, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        window.location.assign(this.dataset.cart);
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
        buttons.forEach(button => button.disabled = false);
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twilly-shop-reel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('twilly-reel')) {
  customElements.define('twilly-reel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const video = this.querySelector('video');
      if (video && window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
      this.querySelector('[data-open-look]')?.addEventListener('click', event => {
        event.preventDefault();
        const products = this.querySelector('details');
        products.open = true;
        products.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        products.querySelector('summary')?.focus({preventScroll:true});
      });
      this.querySelector('[data-sound]')?.addEventListener('click', event => {
        if (!video) return;
        video.muted = !video.muted;
        event.currentTarget.setAttribute('aria-pressed', String(!video.muted));
        this.querySelector('[data-sound-state]').textContent = video.muted ? ' ×' : '';
      });
      this.querySelector('[data-pause]')?.addEventListener('click', event => {
        if (!video) return;
        if (video.paused) video.play().catch(() => {}); else video.pause();
        event.currentTarget.setAttribute('aria-pressed', String(video.paused));
        event.currentTarget.querySelector('span').textContent = video.paused ? '▶' : 'Ⅱ';
      });
      this.addEventListener('change', (event) => {
        if (event.target.matches('select[name="id"]')) {
          const option = event.target.selectedOptions[0];
          event.target.closest('[data-item]').querySelector('[data-price]').textContent = option.dataset.price;
        }
      });
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('[data-look-form]')) return;
        event.preventDefault();
        this.addItems([{id: Number(new FormData(event.target).get('id')), quantity: 1}]);
      });
      this.querySelector('[data-add-all]')?.addEventListener('click', () => {
        const items = Array.from(this.querySelectorAll('[data-item]'))
          .filter(row => row.querySelector('[data-include]').checked && !row.querySelector('[data-include]').disabled)
          .map(row => ({id: Number(row.querySelector('select[name="id"]').value), quantity: 1}));
        if (!items.length) {
          this.querySelector('[role="status"]').textContent = this.dataset.empty;
          return;
        }
        this.addItems(items);
      });
    }
    async addItems(items) {
      if (this.busy) return;
      this.busy = true;
      const buttons = Array.from(this.querySelectorAll('button:not(:disabled)'));
      buttons.forEach(button => button.disabled = true);
      const status = this.querySelector('[role="status"]');
      status.textContent = '';
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.add, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        window.location.assign(this.dataset.cart);
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
        buttons.forEach(button => button.disabled = false);
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
